import React from "react";
import { TextButton, ModalButtonsContainer } from "@SeemplicityDev/shared";
import useFormWizard from "./FormWizardProvider";

export const nextButtonName = "next-page-wizard-button";
export const backButtonName = "prev-page-wizard-button";

interface FormWizardButtonsProps {
  isValid: boolean;
  "data-testid"?: string;
}

const FormWizardButtons: React.FC<FormWizardButtonsProps> = ({
  isValid,
  "data-testid": dataTestId,
}) => {
  const {
    isFirstStep,
    isLastStep,
    isFormSubmitting,
    handleCancel,
    dangerSubmit,
    analyticsStepId,
  } = useFormWizard();

  return (
    <div className="form-wizard-buttons">
      <ModalButtonsContainer>
        {!isFirstStep && (
          <TextButton
            data-testid={`${dataTestId}-back-button`}
            type="submit"
            label={"Back"}
            name={backButtonName}
            data-analytics-event="user_click"
            data-analytics-props={`{"name": "back_btn", "step": "${analyticsStepId}"}`}
          />
        )}
        <TextButton
          data-testid={`${dataTestId}-cancel-button`}
          type="button"
          label={"Cancel"}
          // main binds handleCancel (href?: string) directly to onClick, so the
          // click event is forwarded as `href`. Cast preserves that runtime.
          onClick={
            handleCancel as unknown as (
              e: React.MouseEvent<HTMLButtonElement>
            ) => void
          }
          data-analytics-event="user_click"
          data-analytics-props={`{"name": "cancel_btn", "step": "${analyticsStepId}"}`}
        />
        <TextButton
          data-testid={`${dataTestId}-next-button`}
          type="submit"
          label={isLastStep ? "Confirm" : "Next"}
          buttonStyle={dangerSubmit && isLastStep ? "danger" : "primary"}
          name={nextButtonName}
          disabled={!isValid || isFormSubmitting}
          isSubmitting={isFormSubmitting}
          rightIcon={isFormSubmitting ? "seem-icon-spinner spinner" : ""}
          data-analytics-event="user_click"
          data-analytics-props={`{"name": "${isLastStep ? "create_btn" : "next_step_btn"}", "step": "${analyticsStepId}"}`}
        />
      </ModalButtonsContainer>
    </div>
  );
};

export default FormWizardButtons;
